import { render, staticRenderFns } from "./ChangeStatusButton.vue?vue&type=template&id=7efdbcd6"
import script from "./ChangeStatusButton.vue?vue&type=script&lang=ts"
export * from "./ChangeStatusButton.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports